import { InAppKeyboardLayoutId } from '~/in-app-keyboard/types/inAppKeyboard.types'
import { BadgeImage } from '~/shared/types/bootcampBadge.types'
import {
  ActivityQuestionType,
  CircleCombinationsQuestion,
  FillInTheBlankQuestion,
  MultipleChoiceQuestion,
  MatchingPairsQuestion,
  NumberLineQuestion,
  MeasureTheItemQuestion,
} from '~/types/bootcamp'

import { BossBattleEnemy } from '~/bootcamp/components/Quiz/QuizProps.models'

import { CategorizationQuestion } from '~/bootcamp/Activities/SanityActivities/Categorization/types/Categorization.type'

import { OrderElementsQuestion } from '~/bootcamp/Activities/SanityActivities/OrderElements/types/OrderElements.types'

import { BossBehaviors } from '../../Activities/types/activities.types'

export interface QuizIntroModel {
  description: string
  introImageUrl?: string
}

export interface QuizInstructionModel {
  title: string
  description: string
}

export interface Activity {
  name: string
  questionType: ActivityQuestionType
  type: number
  activityWeight: number
  difficultyLevel: number
  keyboardLayout?: InAppKeyboardLayoutId | null
  level: number
  description?: unknown[]
  multipleChoiceActivity: MultipleChoiceQuestion[]
  fillInTheBlankActivity: FillInTheBlankQuestion[]
  circleCombinationsActivity: CircleCombinationsQuestion[]
  categorizationActivity: CategorizationQuestion[]
  matchingPairsActivity: MatchingPairsQuestion[]
  orderElementsActivity: OrderElementsQuestion[]
  numberLineActivity: NumberLineQuestion[]
  measureTheItemActivity: MeasureTheItemQuestion[]
}

export interface QuizQuestionModel {
  activity: Activity[]
  repeat: number
  shuffle: boolean
  take: number
  bootcampKey: string
  bootcampSubtopic: string
}

export interface QuizQuestionConfig {
  questions: QuizQuestionModel[]
  repeat: number
  random: boolean
  maxWrongAnswer: number
}

export interface QuizResultModel {
  dummy: string
}

export interface QuizDataModel {
  key: string
  subtopic: string
  intro: QuizIntroModel
  instruction?: QuizInstructionModel
  questionConfig: QuizQuestionConfig
  result?: QuizResultModel
}
export enum BossSoundState {
  MUTE = 'mute',
  UNMUTE = 'unmute',
}
export interface QuizBossState {
  hasStartedQuiz?: boolean
  bossCurrentBehavior?: BossBehaviors | null
  bossIsBusy?: boolean
  bossDamageAmount?: number
  bossResponse?: {
    state: 'ready'
    anim?: string | null
  }
  bossSound?: BossSoundState
}
export interface QuizState extends QuizBossState {
  startTime: Date | string | null
  endTime?: Date | string
  bootcampKey: string | null
  subtopic: string | null
  bossHealth: number
  damagePlayer: boolean
  totalQuestions: number
  completedQuestions: number
  wrongAnswer: number
  maxWrongAnswer: number
  questions: Array<{
    activity: Activity
    pass: boolean | null
  }>
  badgeImage: BadgeImage
  mathEnergyEarned?: number
  bossBattleEnemy: BossBattleEnemy
}
